import { ProfileResource, profileResource } from '@witkac/kartamiejska-resources';
import { Profile, ProfileFilter, ProfileType } from '@witkac/kartamiejska-shared';

import { EntityModule } from './entity.module';

/**
 * Moduł urzędników
 *
 * @export
 * @class OfficialsModule
 * @extends {EntityModule<Profile, ProfileResource>}
 */
export class OfficialsModule extends EntityModule<Profile, ProfileResource> {
  constructor() {
    super(profileResource);
    /**
     * Stan store
     *
     * @memberof ClientModule
     */
    this.state = {
      ...this.state,
      data: {
        profile: {
          id: undefined,
          firstName: undefined,
          lastName: undefined,
          email: undefined,
          phoneNumber: undefined,
          companyName: undefined,
          companyPosition: undefined,
          userId: undefined,
          user: {
            userId: undefined,
            state: undefined
          }
        },
        login: undefined
      }
    };

    const listAction = this.actions.list;
    this.actions = {
      ...this.actions,
      /**
       * Pobranie listy urzędników
       *
       * @param context context
       * @param filters filtry
       */
      list: async (context: any, filters: ProfileFilter = {}): Promise<void> => {
        filters.type = ProfileType.OFFICIAL;
        await listAction(context, filters);
      },
      /**
       * Dodaje profil urzędnika
       *
       * @param context context
       * @param data dane do wysłania do API
       */
      add: async (context: any, data: any) => {
        data.profile.id = await this.resource.add(data);
        await listAction(context, { count: 0, type: ProfileType.OFFICIAL });
      },
      /**
       * Aktualizuje profil urzędnika
       *
       * @param context context
       * @param data dane do wysłania do API
       */
      update: async (context: any, data: { id: number; profile: Profile }) => {
        const userId = data.profile.userId;
        delete data.profile.userId;
        data.profile.id = await this.resource.update(data.id, data.profile);
        data.profile.userId = userId;
        context.commit('update', data.profile);
        context.commit('setEntity', data.profile);
      }
    };

    this.mutations = {
      ...this.mutations,
      /**
       * Zapisuje urzędnika do store
       *
       * @param localState stan lokalny
       * @param profile profil klienta
       */
      setEntity(localState: any, profile: any): void {
        Object.keys(localState.data.profile)
          .filter(key => profile[key] !== undefined)
          .forEach(key => (localState.data.profile[key] = profile[key]));
        if (profile.user) {
          localState.data.login = profile.user.login;
        }
      }
    };
  }
}

export default new OfficialsModule();
